export default "__VITE_ASSET__CjjJsBeh__"